import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/plat/admin/giftCode/redemptionRecord/';

function baseApi() {

    function query(data) {
        return Post(baseUrl + 'queryGiftCodeRedemptionRecord', data);
    }

    return {
        query
    };
}

export const giftRedemptionRecordApi = baseApi();
